import { render, staticRenderFns } from "./AboutGerminate.vue?vue&type=template&id=3eeb8911&scoped=true&"
import script from "./AboutGerminate.vue?vue&type=script&lang=js&"
export * from "./AboutGerminate.vue?vue&type=script&lang=js&"
import style0 from "./AboutGerminate.vue?vue&type=style&index=0&id=3eeb8911&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeb8911",
  null
  
)

export default component.exports